import apiService from '@/services/apiService';

const actions = {
  getMainFeatures({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/main-features/find-with-paging', payload)
        .then((response) => {
          commit('SET_MAIN_FEATURES', response.data.data.results);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getMainFeature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxelmarket/main-features/${payload}`)
        .then((response) => {
          commit('SET_MAIN_FEATURE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderMainFeature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/main-features/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postMainFeature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/main-features', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putMainFeature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/main-features/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delMainFeature({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`paxelmarket/main-features/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },

};

export default actions;
